import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from '@mui/material';

export default function AddInvestorModal({ open, onClose, onAddInvestor }) {
  const [newInvestor, setNewInvestor] = useState({
    displayName: '',
    email: '',
  });

  const handleAddInvestor = async () => {
    if (!newInvestor.email || !newInvestor.displayName) {
      return; // Basic validation
    }

    try {
      // Create a new investor object
      const investorToAdd = {
        id: `investor_${Date.now()}`,
        ...newInvestor,
        userType: 'investor',
        profilePhoto: null, // Default profile photo
        createdAt: new Date().toISOString(),
      };

      // Call the parent callback
      onAddInvestor(investorToAdd);

      // Reset form and close modal
      setNewInvestor({
        displayName: '',
        email: '',
      });
      onClose();

    } catch (error) {
      console.error('Error adding investor:', error);
    }
  };

  const handleClose = () => {
    // Reset form when closing
    setNewInvestor({
      displayName: '',
      email: '',
    });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ color: '#008080' }}>
        Add New Investor
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Full Name"
            value={newInvestor.displayName}
            onChange={(e) => setNewInvestor(prev => ({ ...prev, displayName: e.target.value }))}
            sx={{ mb: 2 }}
            required
            autoFocus
          />
          <TextField
            fullWidth
            label="Email Address"
            type="email"
            value={newInvestor.email}
            onChange={(e) => setNewInvestor(prev => ({ ...prev, email: e.target.value }))}
            sx={{ mb: 2 }}
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          sx={{ color: 'text.secondary' }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleAddInvestor}
          variant="contained"
          disabled={!newInvestor.displayName || !newInvestor.email}
          sx={{
            backgroundColor: '#008080',
            '&:hover': {
              backgroundColor: '#005252'
            },
            '&:disabled': {
              backgroundColor: 'grey.400'
            }
          }}
        >
          Add Investor
        </Button>
      </DialogActions>
    </Dialog>
  );
}
